import {
  Form,
  Select,
  Row,
  Col,
  Button,
  Modal,
  AutoComplete,
  Input,
  Spin,
  Icon,
  message
} from "antd";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import _ from "lodash";
import NumericInput from "../NumericInput";
import {
  showSuccessNotification,
  showErrorNotification,
  strings,
  getProp
} from "../../helpers";
import { getSubscriptionPlans, saveManualSubscription } from "../../services";
const FormItem = Form.Item;
const { Option } = Select;

class UserSubscriptionModal extends Component {
  state = {
    subcriptionPlans: []
  };

  componentDidMount() {
    this.fetchSubscriptionsList();
  }

  /**
   * @function fetchSubscriptionsList
   * @description it will fetch subscription plans.
   */
  fetchSubscriptionsList = () => {
    getSubscriptionPlans().then(response => {
      if (response.data.success) {
        this.setState({ subcriptionPlans: response.data.data.plans });
      }
    });
  };
  /**
   * @function saveSubscriptionAddded
   * @description it will save form data and hit the api
   */
  saveSubscriptionAddded = e => {
    const {
      form,
      isProcessing,
      userDetails,
      toggleSubscriptionModal,
      toggleIsProcessing,
      stopIsProcessing,
      fetchUsersDetails
    } = this.props;
    e.preventDefault();

    form.validateFieldsAndScroll((err, value) => {
      if (!err) {
        toggleSubscriptionModal();
        toggleIsProcessing();

        this.setState({ isProcessing: true });
        const subscribedPlan = {
          billing_plan_id: value.billingPlan,
          razorpay_payment_id: value.paymenyId,
          razorpay_order_id: value.orderId,
          gstin: value.gstin
        };

        const userid = userDetails.id;
        saveManualSubscription(subscribedPlan, userid)
          .then(response => {
            if (response.data.success) {
              const successMsg = response.data.message;
              showSuccessNotification(successMsg);
              this.props.fetchUsersDetails(userid);
            } else {
              const { errors } = response.data.error;
              let error = errors;
              showErrorNotification(error);
            }
            stopIsProcessing();
          })

          .catch(response => {
            const getErrors = getProp(["data", "errors"]);
            if (getErrors(response)) {
              const { errors } = response.data;
              let error = errors;
              if (Array.isArray(errors)) {
                error = errors[0];
              }
              showErrorNotification(error.title);
            }
          });
      }
    });
  };

  /**
   * @function handleChange
   * @description it will execute when user change the plan
   */
  handleChange = value => {};

  render() {
    const { getFieldDecorator } = this.props.form;
    const { showAddSubscriptionModal, toggleSubscriptionModal } = this.props;
    const { subcriptionPlans } = this.state;

    return (
      <Modal
        maskClosable={false}
        destroyOnClose
        title={"Add Manual Subscription"}
        visible={showAddSubscriptionModal}
        onCancel={toggleSubscriptionModal}
        footer={null}
        className="user-subscription-modal no-footer"
      >
        <Form
          onSubmit={this.saveSubscriptionAddded}
          layout="vertical"
          className="mt-20"
        >
          <Row type="flex" justify="space-between" gutter={20}>
            <Col span={12}>
              <FormItem label={"Billing plan"}>
                {getFieldDecorator("billingPlan", {
                  initialValue: "Select subscription plan",
                  rules: [
                    {
                      required: true,
                      message: `${"select subscription plan"}`
                    }
                  ]
                })(
                  <Select onChange={this.handleChange}>
                    {subcriptionPlans &&
                      subcriptionPlans.map(item => (
                        <Option value={item.id} key={item.id}>
                          {item.name} ({item.interval} -{" "}
                          {item.period === "monthly"
                            ? "months"
                            : `${item.period}`}
                          ) - {item.amount}
                        </Option>
                      ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={"Payment Id"}>
                {getFieldDecorator("paymenyId", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: `${"enter payment id"}`
                    }
                  ]
                })(
                  <Input className="ant-input" placeholder="Enter payment id" />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row type="flex" justify="space-between" gutter={20}>
            <Col span={12}>
              <FormItem label={"Order Id"}>
                {getFieldDecorator("orderId", {
                  initialValue: "",
                  rules: [
                    {
                      required: true,
                      message: `${"enter order id"}`
                    }
                  ]
                })(
                  <Input className="ant-input" placeholder="Enter order id" />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={"Gstin"}>
                {getFieldDecorator("gstin", {
                  initialValue: ""
                })(
                  <Input
                    className="ant-input"
                    placeholder="Enter gstin number"
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row className="modal-footer-row">
            <Col span={24}>
              <Button type="primary" htmlType="submit" size="small">
                {"Add"}
              </Button>
              <Button
                size="small"
                className="ml-8"
                onClick={() => {
                  toggleSubscriptionModal();
                }}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

const WrappedRegistrationForm = Form.create()(UserSubscriptionModal);
export default WrappedRegistrationForm;
